// src/constants/apiUrls.ts
export const BILLING_STATUS_API = '/api/billing/status';
export const BILLING_CREATE_API = '/api/billing/create';
export const BILLING_CANCEL_API = '/api/billing/cancel';
export const AUTH_CHECK_API = '/api/auth/check';
export const CHECK_SHOP_API = '/api/check-shop';
export const RECOMMENDATIONS_API = '/api/recommendations';
export const CREATE_RECOMMENDATION_API = '/api/recommendations/create';
export const RECOMMENDATION_STATS_API = '/api/recommendation-stats';
export const SHOPIFY_INSTALL_API = '/shopify/install';
export const FETCH_PRODUCTS_API = '/api/products';
export const FETCH_AI_SUGGESTIONS_API = 'api/ai-suggestions';
export const BULK_CREATE_RECOMMENDATIONS_API = '/api/recommendations/bulk-create';
export const PRODUCTS_SYNC_API = '/api/products/sync';
export const AI_SUGGESTIONS_PROGRESS_API = '/api/suggestions/progress';
